import { render, staticRenderFns } from "./grabbing.vue?vue&type=template&id=3c45f567&scoped=true&"
import script from "./grabbing.vue?vue&type=script&lang=js&"
export * from "./grabbing.vue?vue&type=script&lang=js&"
import style0 from "./grabbing.vue?vue&type=style&index=0&id=3c45f567&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45f567",
  null
  
)

export default component.exports